import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function lockTripFolder(id: number) {
  return restApiClient.url(constructApiUrl(API.tripFolder.lock.url, { id })).patch()
}
